import { render, staticRenderFns } from "./ExamineShop.vue?vue&type=template&id=3cc0b485&scoped=true"
import script from "./ExamineShop.vue?vue&type=script&lang=ts"
export * from "./ExamineShop.vue?vue&type=script&lang=ts"
import style0 from "./ExamineShop.vue?vue&type=style&index=0&id=3cc0b485&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc0b485",
  null
  
)

export default component.exports